import Page from "components/Page";
import styles from "./../aisettings.module.scss";
import { withTranslation } from "react-i18next";
import constants from "../../../../constants";
import Text from "components/Text";
import React, { useState, Suspense } from "react";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import Card from "components/Card";
import Loader from "components/Loader";
import { getStorage, removeStorage, setStorage } from "utils";
import Ongoing from "./components/Ongoing";
import Archive from "./components/Archive";

function ReportedResponses({ history, t }) {
  const goBack = () =>
    history.push({ pathname: constants.routes.aiAssistant.aiSetting });

  /* Initializations & Declarations */
  const cachedActiveTab = getStorage(
    constants.aiSettings.cache.reviewRatinglisting
  );

  const [activeTab, setActiveTab] = useState(
    cachedActiveTab?.activeTab ? cachedActiveTab.activeTab : 1
  );

  const tabName = constants.reviewRatingTabStatus;

  const manageTab = (tab) => {
    window.scrollTo(0, 0);
    setActiveTab(tab);
    setStorage(constants.aiSettings.cache.reviewRatinglisting, {
      activeTab: tab,
    });
  };

  const renderHeader = () => (
    <div className="content_wrapper_pms">
      <div>
        <h2 className="title pms_heading page_title_margin_top page_title_margin_bottom">
          {t("aiAssistant.responseReport")}
        </h2>
        <Text size="14px" weight="300" color="#000000">
          {t("aiAssistant.aiAssistSubheading")}
        </Text>
      </div>
    </div>
  );

  return (
    <>
      <Page onBack={() => goBack()} className={styles["global-main-page"]}>
        {renderHeader()}
        <Card className="mt-4 p-4">
          <div className={"common-tabs scheduler-tabs "}>
            <Nav tabs className={""}>
              <NavItem>
                <NavLink
                  className={activeTab == tabName.ongoing ? "active" : ""}
                  onClick={() => manageTab(tabName.ongoing)}
                >
                  {t("aiAssistant.ongoing")}
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink
                  className={activeTab == tabName.archive ? "active" : ""}
                  onClick={() => manageTab(tabName.archive)}
                >
                  {t("aiAssistant.archived")}
                </NavLink>
              </NavItem>
            </Nav>
            <TabContent activeTab={activeTab}>
              <Suspense fallback={<Loader />}>
                <TabPane tabId={1}>
                  {activeTab === tabName.ongoing && (
                    <Ongoing status={activeTab} />
                  )}
                </TabPane>
                <TabPane tabId={2}>
                  {activeTab === tabName.archive && (
                    <Archive status={activeTab} />
                  )}
                </TabPane>
              </Suspense>
            </TabContent>
          </div>
        </Card>
      </Page>
    </>
  );
}

export default withTranslation()(ReportedResponses);
